module.exports = {"611026001":"乾佑街道","611026101":"营盘镇","611026102":"下梁镇","611026104":"小岭镇","611026105":"凤凰镇","611026106":"红岩寺镇","611026107":"曹坪镇","611026109":"杏坪镇","611026110":"瓦房口镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/611026.json
// module id = 2889
// module chunks = 0